import { ChevronLeft, Store } from "lucide-react";

// Relative imports on purpose: vitest.config.ts does not alias "@".
import { BlogAnchor } from "./BlogAnchor";
import { useBlogPost } from "./BlogPostContext";

const CARD_CLASS =
  "flex items-center gap-4 my-6 bg-white border border-gray-200 rounded-xl p-4 hover:border-warmOrange-500 transition-colors motion-reduce:transition-none min-h-11 no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warmOrange-500";

/**
 * `<StoreCard slug />` in MDX: one link to the store page, where the reviews are. It carries no
 * rating, review count or badge: the card points at evidence, it does not grade the store. The
 * snapshot store is handed to BlogAnchor so the click carries storeEventProps. A missing slug
 * degrades to the plain slug text (the build validator is the real guard).
 */
export function BlogStoreCard({ slug }: { slug: string }) {
  const { snapshot } = useBlogPost();
  const store = snapshot?.stores?.[slug];

  if (!store) {
    console.error(`[blog] StoreCard: unknown snapshot store "${slug}"`);
    return <span dir="auto">{slug}</span>;
  }

  return (
    <BlogAnchor
      href={`/store/${encodeURIComponent(store.slug)}`}
      className={CARD_CLASS}
      store={store}
    >
      {store.logoUrl ? (
        <img
          src={store.logoUrl}
          alt=""
          width={40}
          height={40}
          loading="lazy"
          className="h-10 w-10 shrink-0 rounded-lg object-cover border border-gray-100"
        />
      ) : (
        <span className="h-10 w-10 shrink-0 rounded-lg bg-gray-100 flex items-center justify-center">
          <Store className="h-5 w-5 text-gray-500" aria-hidden="true" />
        </span>
      )}
      <span className="min-w-0 flex-1">
        <span className="block font-bold text-gray-900 truncate" dir="auto">
          {store.name}
        </span>
        {store.categoryTitle ? (
          <span className="block text-sm text-gray-500">{store.categoryTitle}</span>
        ) : null}
      </span>
      <span className="flex items-center gap-1 shrink-0 text-sm font-bold text-warmOrange-700">
        شوف تقييمات المتجر
        <ChevronLeft className="h-4 w-4" aria-hidden="true" />
      </span>
    </BlogAnchor>
  );
}

export default BlogStoreCard;
